import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, Optional, Self } from '@angular/core'
import { ControlValueAccessor, FormControl, NgControl, ValidatorFn, Validators } from '@angular/forms'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { UtilityService } from '@core/services/utility.service'

@Component({
  selector: 'lin-mac-address-form-field',
  templateUrl: './mac-address-form-field.html',
  styles: [
    `
      :host ::ng-deep .mat-mdc-form-field {
        width: 100%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MacAddressFormFieldComponent implements ControlValueAccessor, Validators, OnInit, OnDestroy {
  control: FormControl = new FormControl()

  private readonly onDestroy$ = new Subject<void>()

  onTouched: () => void = () => {
    // empty
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (value: any) => void = () => {
    // empty
  }

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private readonly utilityService: UtilityService,
  ) {
    if (this.ngControl) this.ngControl.valueAccessor = this
  }

  ngOnInit(): void {
    this.initListenerControlValueChanges()
    this.updateValidators()
  }

  private updateValidators(): void {
    const validators: ValidatorFn = this.ngControl.control.validator
    this.control.setValidators(validators ? validators : null)
    this.control.updateValueAndValidity()
  }

  private initListenerControlValueChanges(): void {
    this.control.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((value: string) => this.valueChanged(value))
  }

  private valueChanged(value: string): void {
    const transformedValue: string = this.utilityService.toMacAddress(value) || null
    this.control.setValue(transformedValue, { emitEvent: false })
    this.onChange(transformedValue)
  }

  writeValue(value: string): void {
    this.control.setValue(value)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.onChange = fn
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.onTouched = fn
  }

  ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
